import { gql } from '@apollo/client/core';

export const FETCH_PARENT_JOBS = gql`
  query fetchParentJobs {
    viewer(kind: PARENT) {
      ... on Parent {
        jobs(jobStatuses: [OPEN]) {
          edges {
            node {
              id
              title
              careType
            }
          }
        }
      }
    }
  }
`;

// Sitter details for the interview request flow
export const SITTER_FOR_INTERVIEW_QUERY = gql`
  query sitterForInterview($accountId: UUID!) {
    account(id: $accountId) {
      ... on Sitter {
        id
        displayName
        photoUrl
        providerType
        reviews {
          totalReviewCount
          starAggregate
        }
        profiles {
          babysitter {
            profile {
              payRate {
                min
                max
              }
            }
          }
        }
      }
    }
  }
`;
